import { SliderData } from './SliderData'
import { useState, useEffect } from 'react'
import { FaArrowAltCircleRight, FaArrowAltCircleLeft } from 'react-icons/fa'


const ImageSlider = ({ slides }) => {
    const[current, setCurrent] = useState(0)
    const length = slides.length

    const nextSlide = () => {
        setCurrent(current === length -1 ? 0 : current + 1)
    }

    const prevSlide = () => {
        setCurrent(current === 0 ? length - 1 : current - 1)
    }

    console.log(current)


    //To make this app work as a timed slideshow, use the code below, take out 
    // the buttons and import useEffect. take out prevSlide

    // const rotate = () => {
    //     window.setTimeout(() => {
    //         nextSlide()
    //     }, 4000)
    //     }

    // useEffect(() => {
    //     rotate()
    //     console.log('use effect')
    // },[current]) 

    if(!Array.isArray(slides) || slides.length<=0) {
        return null
    }

    return (
        <div>
            <section className="slider">
                {
                    SliderData.map((slide, index) => {
                        return(
                            <div className={index === current ? 'slide active' : 'slide'} key={index}>
                                {index === current && (<img src={slide.image} alt="Failed to load" className="image"/>)}
                                <FaArrowAltCircleLeft className='left-arrow' onClick={prevSlide}/>
                                <FaArrowAltCircleRight className='right-arrow' onClick={nextSlide}/>
                            </div>

                        )
                    })
                }
            </section>
        </div>
    )
}

export default ImageSlider